import MainFooter from "./MainFooter";

export default MainFooter;
